// extracted by mini-css-extract-plugin
export default {"Navbar":"Navbar_Navbar__zhNGE","logo":"Navbar_logo__7As90","slider":"Navbar_slider__GTRhO","selectContainer":"Navbar_selectContainer__vEml5"};